import { useEffect } from 'react';
import type React from 'react';

/**
 * Calls `onOutsideClick` when a mousedown event occurs outside all provided refs.
 */
export function useOutsideClick(
    refs: React.RefObject<HTMLElement | null>[],
    isActive: boolean,
    onOutsideClick: () => void,
): void {
    useEffect(() => {
        if (!isActive) return;

        const handler = (e: MouseEvent) => {
            const target = e.target as Node;
            const isInside = refs.some(
                (ref) => ref.current && ref.current.contains(target),
            );
            if (!isInside) {
                onOutsideClick();
            }
        };

        document.addEventListener('mousedown', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [refs, isActive, onOutsideClick]);
}
